import { useUserStore } from '@/stores/userStore';
import mixpanel from 'mixpanel-browser';
import { computed } from 'vue';

/**
 * Define common properties for mixpanel track events here
 * and identify a user if possible
 * @param {string} label - The label of the event to track
 */
const useCommonProperties = (label = null) => {
  const userStore = useUserStore();
  const user = computed(() => userStore.user);

  const data = {
    Label: label,
    $insert_id: crypto.randomUUID(),
  };

  if (user.value?.mixpanel_distinct_id) {
    // TODO: Ideally we don't call identify on every event as it spams the logs
    // it's safe to do so, but it's recommended to only call it once per session
    // however from a few tests I can't verify that the existing user_id or distinct_id
    // in the cookie matches the user.mixpanel_distinct_id we are passing in here so can't be sure
    // it hasn't already been called
    data.distinct_id = user.value.mixpanel_distinct_id;

    mixpanel.disguise.identify(user.value.mixpanel_distinct_id);
  }

  return data;
};

export default useCommonProperties;
